import { useQuery } from "@apollo/client"
import { GridRowModel, GridColDef } from "@mui/x-data-grid"
import { differenceInYears } from "date-fns"
import { useEffect, useState } from "react"
import { Header, TableStandard } from "ui"
import { GET_COMPANY_STUDENTS } from "../../queries"
export type basicStudentInfo = { __typename: string | undefined, id: string, dob: string }

const TABLE_COLUMNS: GridColDef[] = [{
    field: "ageGroup", headerName: "Age Group", flex: 1, sortable: true, resizable: false, editable: false, disableColumnMenu: true
}, {
    field: "count", headerName: "Total", flex: 1, sortable: true, resizable: false, editable: false, disableColumnMenu: true
}]
const AGE_BUCKET = {
    "8 or below": 0,
    "9": 0,
    "10": 0,
    "11": 0,
    "12": 0,
    "13": 0,
    "14": 0,
    "15": 0,
    "16": 0,
    "17": 0,
    "18+": 0
};
const getAgeBucket = (age: number) => {
    if (age <= 8) return "8 or below";
    if (age >= 18) return "18+";
    return age.toString();
}
function calculateAge(dob: Date) {
    return differenceInYears(new Date(), dob);
}

function mapToTable(data: any) {
    const freq = data.reduce((acc: any, row: any) => {
        if (!row.dob) return acc;
        const age = calculateAge(row.dob);
        const bucket = getAgeBucket(age);
        acc[bucket] += 1;
        return acc;
    }, { ...AGE_BUCKET })
    const rows = Object.entries(freq).map(([ageGroup, count], index) => ({
        id: index,
        ageGroup,
        count,
    })).sort(
        (a, b) => {
            if (a.ageGroup === "8 or below") return -1;
            if (b.ageGroup === "8 or below") return 1;
            return Number(a.ageGroup) - Number(b.ageGroup);
        }
    );
    return rows;
}
const SessionAgeSort = ({ students, companyId }: { students: basicStudentInfo[], companyId: string }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        studentCount: number,
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        studentCount: 0,
        filteredRows: [],
        status: "NORMAL"
    })

    const { loading, data } = useQuery(GET_COMPANY_STUDENTS, {
        variables: { id: companyId }
    })
    useEffect(() => {
        if (data) {
            setPageTableState((prevState) => {
                const columns = [...TABLE_COLUMNS]
                const rows = mapToTable(students)
                const totalCount = students.length;
                return {
                    ...prevState,
                    columns,
                    rows: rows,
                    studentCount: totalCount
                }
            })
        }
    }, [loading, data, students])

    return (
        <TableStandard
            renderToolbar={() => (
                <Header title={`Total number of Students: ${pageTableState.studentCount} `} titleSize="p" />
            )}
            rows={pageTableState.rows}
            columns={pageTableState.columns}
            hideFooter={true}
            loading={loading}
            disableBoxShadow
        />
    )
}
export default SessionAgeSort